module.exports = __webpack_public_path__ + "media/hashalem-optimized.59c87673.mp4";